import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { ClassesUtil } from '../utils/classes-util';
import { CookiesUtil } from '../utils/cookies-util';
import { WindowRef } from '../utils/window';

import { Router } from '@angular/router';
import { Subject ,  Observable ,  Subscription } from 'rxjs';
import { APP_CONSTANTS } from '../utils/app-constants';
import { AuthorizationService } from '../components/authorization/authorization.service';
import { FormGroup, Validators, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateUtil } from '../utils/translate-util';
import { TranslateService } from '@ngx-translate/core';
import { RecaptchaLoaderService } from '../utils/recaptchaLoader.service';
import { DTFHomepageService } from '../components/dtfhomepage/dtfhomepage.service'
import { HttpHeaders } from '@angular/common/http';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { NgOtpInputModule } from 'ng-otp-input';
import { SharedTranslateModule } from '../utils/sharedTranslateModule';
import { RegistrationPopupComponent } from '../components/registrationPopup/registrationPopup.component';
import { PasswordResetComponent } from '../components/passwordreset/passwordreset.component';
import { ForgotUserComponent } from '../components/forgotUser/forgotUser.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { RegistrationConfirmComponent } from '../components/registrationConfirm/registrationConfirm.component';
import { AlertPageComponent } from './alert.component';
import { ResetpasswordComponent } from '../resetpassword/resetpassword.component';
import { PasswordResetConfirmComponent } from '../components/passwordresetconfirm/passwordresetconfirm.component';
import { Banner } from '../shared/models/banner';
import { Location } from '@angular/common';
import { DTFService } from '../dtf.service';
import { S } from '@angular/cdk/scrolling-module.d-ud2XrbF8';


declare let gtag: Function;


@Component({
    selector: 'mbfs-header',
    imports: [SharedTranslateModule, RegistrationPopupComponent, ForgotUserComponent, MainNavComponent,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, NgOtpInputModule, AlertPageComponent, MatSortModule, ResetpasswordComponent
    ],
    templateUrl: './header.component.html',
    providers: [ClassesUtil, CookiesUtil, WindowRef]
})

export class HeaderComponent implements OnInit {

    constructor(private classesUtil: ClassesUtil, cookies: CookiesUtil, router: Router, window: WindowRef,
                public auth: AuthorizationService, private fb: FormBuilder,public translateUtil: TranslateUtil,
                public translate: TranslateService, public recaptchaLoaderService: RecaptchaLoaderService,
                public dtfhomepageService: DTFHomepageService, private location: Location,private dtfService: DTFService
                ) {
        this.router = router;
        this._window = window;
        this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
        this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
        this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    }
    otp: string;
    showOtpComponent = true;
    @ViewChild('ngOtpInput', { static: false}) ngOtpInput: any;
    config = {
      allowNumbersOnly: true,
      length: 6,
      isPasswordInput: false,
      disableAutoFocus: false,
      placeholder: '',
      inputStyles: {
        'width': '30px',
        'height': '40px'
      }
    };
    cookiesUtil: CookiesUtil;
    private _window: WindowRef;
    router: Router;
    public registration: any;
    isAuthenticated = false;
    isAdminAuthenticated = false;
    ciamLoginUrl = '';
    contextPath = '';
    currentCountry: string;
    isCanadaPortal = false;
    email = '';
    MFATimeout = true;
    MFALockout = true;
    isReset = false;
    userExist = false;
    getUserFlag = false;
    MFACheck=false;
    MFAValid=false;
    loginLoaded = true;
    rendered: any;
    captchaToggle = true;
    // currentlanguage: string;
    activateMainNav = true;
    displayCloseIcon = false;
    isAuth = '';
    userId = '';
    password = '';
    language = '';
    defaultHeader='';
    displayDefault=false;
    displayAdmin=false;
    displayFleet=false;
    displayFleetHeader='';
    hide = false;
    openLoginModal = false;
    registrationClick = false;
    serviceErrorOccurred = false;
    serviceErrorDesc = '';
    usUrl: string;
    caUrl: string;
    adminFlow:string;
    brandId: string;
    targetRedirect = '';
    adminRedirect = '';

    registrationRedirect = '';
    baseUrl = '';
    logoutRedirect = '';
    classicRedirect = '';
    environment = '';
    siteKeyCaptcha = '';
    recaptchaResponse = '';
    passwordResetFlag=false;
    forgotUserFlag= false;
    loginmodalFlag = false;
    // Recaptcha related variables
    // lOCAL TESTING SITE KEY
    // siteKeyCaptcha = '6LdgbbUUAAAAADONNVKQp3CrnGq_C7RsQsmwvB6l';
    // Captcha URL
    // private recaptchaURL = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
    // MBFS SITE KEY
    // siteKeyCaptcha = '6LcSOLUUAAAAAJEjAl9EcW4zmRc9G4W1HJ5u4tkJ';
    // siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptcha;
    private recaptchaURL = APP_CONSTANTS.recaptchaURL;
    toggle = false;
    guestPayHeader = '';
    guestPay = false;
    // DTPAY = false;
    azURL: string;
    gaid: number;



    loginForm: FormGroup;
    adminloginForm:  FormGroup;
    userForm: FormGroup;
    adminForm: FormGroup;
    // ciamReCaptchaForm: FormGroup;

    dbData: any;
    public alerts: Banner;
    langFlag: string;

    formValidationClasses = {
      'mbfs-error': true,
    };

    buildForm() {
      this.userForm = this.fb.group({
        userID: [''],
      });
      this.adminForm = this.fb.group({
        userID: [''],
      });
      this.loginForm = this.fb.group({
        userID: [''],
        password: ['']
      });
      this.adminloginForm = this.fb.group({
        userID: [''],
        password: ['']
      });
    //   this.ciamReCaptchaForm = this.fb.group({
    //     recaptchaResponseKey: [null, Validators.required]
    // });
    }

    // selectSiteKey() {
    //   this.environment = (this._window.nativeWindow as any).mbfs.environment;
    //   if (this.environment === 'local') {
    //    this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaLocal;
    //   } else if (this.environment === 'dev') {
    //     this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaDev;
    //   } else if (this.environment === 'stage') {
    //     this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaStage;
    //   } else if (this.environment === 'prod') {
    //     this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
    //   } else {
    //     this.siteKeyCaptcha = APP_CONSTANTS.siteKeyCaptchaProd;
    //   }
    // }

  // getCaptcha() {
  //   this.dtfhomepageService.getCaptcha().subscribe((res) => {
  //     this.captchaToggle = res;
  //   });
  // }

    ngOnInit() {
      const language = (window as any).mbfs.language;
      this.language= language;
      this.langFlag = language;
      this.environment = (this._window.nativeWindow as any).mbfs.environment;
      sessionStorage.removeItem("admincheck");
      this.getAlerts();
      // this.getCaptcha();
      this.translateUtil.setCountryAndLangFromUIProp();
      this.translateUtil.getCurrentCountry().subscribe(val => {
          this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
          this.currentCountry = val;
      });

      const loginmodal = (this._window.nativeWindow as any).mbfs.loginmodal;
      if(loginmodal !=""){
        this.checkLogin();
      }
      this.auth.cast.subscribe(data => (this.isAuthenticated = data));
      this.auth.castadmin.subscribe(data => (this.isAdminAuthenticated = data));
      this.contextPath = (this._window.nativeWindow as any).mbfs.contextPath;
      this.language = (this._window.nativeWindow as any).mbfs.language;
      sessionStorage.setItem('language',this.language);
      this.defaultHeader = (this._window.nativeWindow as any).mbfs.defaultHeader;
      if(this.defaultHeader === "none"){
        this.displayDefault = true;
        this.displayFleet = false;
      }
      // if (this.defaultHeader === "guestpay") {
      //   this.guestPay = true;  
      // }
      this.displayFleetHeader = (this._window.nativeWindow as any).mbfs.displayFleetHeader;
      if(this.displayFleetHeader === "none"){
        this.displayFleet = true;
        this.displayDefault = false;
      }
      this.adminFlow = (this._window.nativeWindow as any).mbfs.adminFlow;
      if(this.adminFlow === "true"){
        this.displayAdmin = true;
        this.displayFleet = false;
        this.displayDefault = true;
      }
      this.auth.isAuthenticated(); // Checks if user is authenticated
      this.auth.isAdminAuthenticated();
      this.buildAccountURL();
      // if ((this._window.nativeWindow as any).mbfs && (this._window.nativeWindow as any).mbfs.captchaToggle) {
      //   this.captchaToggle =
      //       (this._window.nativeWindow as any).mbfs.captchaToggle.toUpperCase() === APP_CONSTANTS.TOGGLE_NO ? false : true;
      //  }
    }

    buildAccountURL() {
      //checks if user is authenticated and builds account redirection URL
      if (this.isAdminAuthenticated) {
        this.adminRedirect = this.usUrl + '/home/admindashboard';
      }
      if (this.isAuthenticated) {
        // Checks if user is authenticated then sets up the My account
        this.brandId = sessionStorage.getItem('brandId');
        if (this.language === 'en-CA' && this.brandId === '3') {
          this.targetRedirect = this.usUrl + '/ca/en/home/dashboard';
        } else if (this.language === 'fr-CA' && this.brandId === '3') {
          this.targetRedirect = this.usUrl + '/ca/fr/home/dashboard';
        } else if (this.brandId === '3') { //If brand ID is 3 account is CA by default
          this.targetRedirect = this.usUrl + '/ca/en/home/dashboard';
        } else {
          this.targetRedirect = this.usUrl + '/home/dashboard';
        }
      }
      }

      onClickGuestPay() {

        this.azURL = this.usUrl + '/home/guestpay';
        setTimeout(() => {
          this._window.nativeWindow.location.href = this.azURL;
        }, 1000);
    
      }

    onClickLogin(e: Event): void {
      this.passwordResetFlag = false;
      this.forgotUserFlag = false;
      if(this.displayAdmin === true){
        this.isReset = false;
      }
      else{
        this.isReset = true;
      }
      this.onClickCloseNewNav(e);
      this.buildForm();
      // this.selectSiteKey(); // used to set Site key based on environment
      //recaptcha script load
      // if(this.language === 'fr-CA') {
      //   this.recaptchaURL = APP_CONSTANTS.recaptchaURLFR;
      // } else {
      //   this.recaptchaURL = APP_CONSTANTS.recaptchaURL;
      // }
      // if (this.captchaToggle) {
      // window['onloadCallback'] = this.onloadCallback.bind(this);
      // window['getResponceCapcha'] = this.getResponceCapcha.bind(this);
      // window['recaptchaResponseExpired'] = this.recaptchaResponseExpired.bind(this);
      // window['recaptchaError'] = this.recaptchaError.bind(this);

      // this.recaptchaLoaderService.loadScript(this.recaptchaURL)
      //     .then(data => {
      //     }).catch(error => console.log(error));
      // }
      //build login form
      this.openLoginModal = true;
      this.userForm.get('userID').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(8),
             Validators.maxLength(60)])
      );
      this.adminForm.get('userID').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(2),
             Validators.maxLength(60)])
      );
      this.adminloginForm.get('userID').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(2),
             Validators.maxLength(60)])
      );
      this.adminloginForm.get('password').setValidators(
            Validators.compose([Validators.required,
              Validators.minLength(12),
              Validators.maxLength(30),
              Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
      );
      this.loginForm.get('userID').setValidators(
        Validators.compose([Validators.required,
             Validators.minLength(8),
             Validators.maxLength(60)])
      );
      this.loginForm.get('password').setValidators(
            Validators.compose([Validators.required,
              Validators.minLength(12),
              Validators.maxLength(30),
              Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
      );
      }

    onRegistrationClick(e: Event){
      this.registrationClick = true;
      this.openLoginModal = false;
      }


    onLogoClick(e: Event): void {
      if (this.language === 'en-CA') {
        this.router.navigate(['ca/en/home']);
      } else if (this.language === 'fr-CA') {
        this.router.navigate(['ca/fr/home']);
      } else {
        this.router.navigate(['home']);
      }
    }

onHamburgerClick(e: Event): void {
  if (e instanceof Event) {
      e.preventDefault();
  }
  if (this.displayCloseIcon) {
      this.onClickCloseNewNav(e);
      return;
  }

  const mainNavs = document.getElementsByClassName('mbfs-main-nav');
  if (mainNavs.length) {
    this.classesUtil.removeClass(mainNavs[0], 'hidden');
    this.classesUtil.addClass(mainNavs[0], 'active');
    const headerHeight = document.getElementById('mbfs-header').clientHeight;
    if (headerHeight > 0) {
          document.getElementById('mbfs-main-nav-content').style.top = `${headerHeight + 15}px`;
      }
    this.displayCloseIcon = true;
}
}

onClickCloseNewNav(e: Event) {
  if (e instanceof Event) {
      e.preventDefault();
      e.stopPropagation();
  }
  let mainNavs = document.getElementsByClassName('mbfs-main-nav');
  if (mainNavs.length) {
      this.classesUtil.removeClass(mainNavs[0], 'active');
      this.classesUtil.addClass(mainNavs[0], 'hidden');
  }
  this.displayCloseIcon = false;
}

    onClickLogout(e: Event): void {
      sessionStorage.removeItem('Authorization');
      sessionStorage.removeItem('userId');
      this.brandId = sessionStorage.getItem('brandId'); //needed to redirect to proper page
      this.classicRedirect = sessionStorage.getItem('classicredirect');

      if(this.isAuthenticated) {
          if (this.language === 'en-CA' && this.brandId === '3') {
            this.logoutRedirect = this.usUrl + '/logout?lang=en-CA&country=CA';
          } else if (this.language === 'fr-CA' && this.brandId === '3') {
            this.logoutRedirect = this.usUrl + '/logout?lang=fr-CA&country=CA';
          } else if (this.brandId === '3') {
            this.logoutRedirect = this.usUrl + '/logout?lang=en-CA&country=CA';
          } else {
            this.logoutRedirect = this.usUrl + '/logout?lang=en-US&country=US';
          }
       // }
        window.location.href = this.logoutRedirect;
      }

      if(this.isAdminAuthenticated) {
        this.logoutRedirect = this.usUrl + '/logout?lang=en-US&country=US';
        window.location.href = this.logoutRedirect;
      }
    }

  clearForm(): void {
    this.userForm.get('userID').patchValue('');
    this.userForm.get('userID').markAsPristine();
    this.userForm.get('userID').markAsUntouched();
    this.userForm.get('userID').updateValueAndValidity();
    this.adminForm.get('userID').patchValue('');
    this.adminForm.get('userID').markAsPristine();
    this.adminForm.get('userID').markAsUntouched();
    this.adminForm.get('userID').updateValueAndValidity();
    this.loginForm.get('userID').patchValue('');
    this.loginForm.get('userID').markAsPristine();
    this.loginForm.get('userID').markAsUntouched();
    this.loginForm.get('userID').updateValueAndValidity();
    this.loginForm.get('password').patchValue('');
    this.loginForm.get('password').markAsPristine();
    this.loginForm.get('password').markAsUntouched();
    this.loginForm.get('password').updateValueAndValidity();
    this.adminloginForm.get('userID').patchValue('');
    this.adminloginForm.get('userID').markAsPristine();
    this.adminloginForm.get('userID').markAsUntouched();
    this.adminloginForm.get('userID').updateValueAndValidity();
    this.adminloginForm.get('password').patchValue('');
    this.adminloginForm.get('password').markAsPristine();
    this.adminloginForm.get('password').markAsUntouched();
    this.adminloginForm.get('password').updateValueAndValidity();
  }

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.registrationClick = false;
    this.isReset = false;
    this.MFACheck = false;
    this.MFAValid = false;
    this.serviceErrorOccurred = false;
  }

  getAlerts() {
    this.dtfhomepageService.getAlerts().subscribe((res) => {
      for (var i = 0; i < res.length; i++) {
        if (this.currentCountry === 'CA') {
          if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
            res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
            this.alerts = res[i];
            this.dbData = true;
          }
        }
        else {
          if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
            this.alerts = res[i];
            this.dbData = true;
          }
        }

        // if (res[i].btnUrl === "DTPAY") {
        //   this.DTPAY = true;
        // }
      }
    });
  }

  submitUserForm(e: Event) {
    if (!this.loginForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
      return;
    }
  //   if (this.captchaToggle) {
  //   if (this.ciamReCaptchaForm.invalid) {
  //     this.translate.get('Errors.recaptcha').subscribe((data: any) => {
  //       this.serviceErrorDesc = data;
  //       return;
  //      });
  //   }
  //  }
    this.userId = this.loginForm.get('userID').value;

  //   if (this.captchaToggle) {
  //   const userRequest = {
  //     userId : this.userId,
  //     recaptcha : this.recaptchaResponse
  //   };
  //   this.getUser(userRequest);
  //  } else {
    const userRequest = {
      userId : this.userId,
      recaptcha : 'false'
    };
    this.getUser(userRequest);
   //}
  }

 
  
  login(){
    this.MFALockout = true;
    this.loginLoaded = false; 
    if (!this.loginForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
      this.loginLoaded = true; 
      return;
    }
    const loginRequest = {
      userId : this.loginForm.get('userID').value,
      password : this.loginForm.get('password').value,
      country: this.currentCountry,
      language : this.language
    };
    this.auth.login(loginRequest).subscribe(res => {
      this.gaid = res.gaid;
      this.loginLoaded = true; 
      if (res.statusMessage === 'FAILURE') {
        this.translate.get('Errors.IncorrectPwd').subscribe((data: any) => {
          this.serviceErrorDesc = data;
        });
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 4000);  //4s
        if(res.message == 'userLocked'){
          this.translate.get('Errors.UserLocked').subscribe((data: any) => {
          this.serviceErrorDesc = data;
        });
        this.serviceErrorOccurred = true;
        }
        if(res.message == 'I'){
          this.translate.get('Errors.UserInactive').subscribe((data: any) => {
          this.serviceErrorDesc = data;
        });
        this.serviceErrorOccurred = true;
        }
      }else if(res.statusMessage === 'SUCCESS'){
        if(res.message ==="maintenance"){
        this.redirectMaintenance();
        return;
      }
      if('N' === res.mfaStatus){
        console.log("MFA not enabled" +res.mfaStatus);
        this.email = res.email;
        this.MFACheck = true;
        this.userExist=true;
        this.openLoginModal=true;
      }else if(res.mfaStatus === 'Y'){
        // this.auth.getLogin(loginRequest).subscribe(res => {
            if (res.userValid === true && res.token !== null){
              sessionStorage.setItem("username", res.userId);
              this.auth.getAuthToken().subscribe(authRes=> {
                sessionStorage.setItem("Authorization", authRes.token);
                sessionStorage.setItem("userId", authRes.userId);
              this.serviceErrorOccurred = false;
              this.environment = (this._window.nativeWindow as any).mbfs.environment;
              this.brandId = res.brandId;
              sessionStorage.setItem('auth', 'yes');
              this.auth.istoken = res.token;
              sessionStorage.setItem('customerName',res.customerName);
              sessionStorage.setItem('emailAddress',res.email);
              sessionStorage.setItem('agentview','false');
              sessionStorage.setItem("environment",this.environment);
              sessionStorage.setItem('ciamToken', this.auth.istoken);
              sessionStorage.setItem('brandId', this.brandId);
              sessionStorage.setItem('classicredirect', 'no');
              sessionStorage.setItem('forward', res.forward);
              sessionStorage.setItem('loginID', res.userId);
              sessionStorage.setItem('thirdPartyNumber', res.thirdPartyNumber);
              sessionStorage.setItem('billingNumber', res.billingNumber);
              sessionStorage.setItem('thirdparty', res.thirdPartyNumber);
              sessionStorage.setItem('paymentLineItem', res.paymentLineItem);
              const thirdparty = res.thirdPartyNumber;
  
              this.auth.isAuthenticated(); // Checks if user is authenticated
              this.openLoginModal = false;    
              if(sessionStorage.getItem('enableGA') === 'yes')  {
              this.getRedirectUrlGA(res.brandId, this.language);
              }
              const redirectUrl = this.getRedirectUrl(res.brandId, this.language);
              if (redirectUrl) {
               this.router.navigate([redirectUrl]).then(() => {
               window.location.reload();
             });
               // this._window.nativeWindow.location.href = redirectUrl;
             } });
             } else if (res.userValid === false && res.token === null) {
              this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
                this.serviceErrorDesc = data;
               });
              this.serviceErrorOccurred = true;
              setTimeout(() => {
                this.serviceErrorOccurred = false;
              }, 2000);  //2s
            } else {
             // If checks to load BE error messages based on language
              if (loginRequest.language === 'en-CA') {
                this.serviceErrorDesc = res.status.message.shortMessage_EN;
              } else if (loginRequest.language === 'fr-CA') {
                this.serviceErrorDesc = res.status.message.shortMessage_FR;
              } else {
                this.serviceErrorDesc = res.status.message.shortMessage;
              }
              this.serviceErrorOccurred = true;
              setTimeout(() => {
                this.serviceErrorOccurred = false;
              }, 2000);  //2s
            }
      // });
      }

      this.MFATimeout=false;
      setTimeout(() => {
        this.MFATimeout = true;
      }, 600000);  //10mins
    }
    })
  }
  private getRedirectUrlGA(brandId: number, language: string) {
    if (brandId === 2) {
      this.environment = (this._window.nativeWindow as any).mbfs.environment;
      if (this.environment === 'stage') {
      this.enableGA("true", "dashboard", this.gaid);
      if (typeof gtag === 'function') {
        gtag('config', 'G-6PHH5S2R0L', {
          user_id: this.gaid
        });
      } else {
        console.warn('gtag is not defined');
      }
    }
    if (this.environment === 'prod') {
      this.enableGA("true", "dashboard", this.gaid);
      if (typeof gtag === 'function') {
        gtag('config', 'G-LVEMHL4CGL', {
          user_id: this.gaid
        });
      } else {
        console.warn('gtag is not defined');
      }
    }
    }
    if (brandId === 3) {
      const langPath = language === 'fr-CA' ? 'fr' : 'en';
      this.enableGA("true", "dashboard", this.gaid);
    }
  }

  enableGA(toggle: string, page:string, userId: number) {
    let redirect = '';
    this.translate.get('LoginModal.GARedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data + toggle +'&page='+ page +'&id=' + userId;
     });
     this._window.nativeWindow.location.href = redirect;
  } 

  private getRedirectUrl(brandId: number, language: string): string {
      if (brandId === 2) {
        return `/home/dashboard`;
      }
      if (brandId === 3) {
        const langPath = language === 'fr-CA' ? 'fr' : 'en';
        return `/ca/${langPath}/home/dashboard`;
      }
      return `/home/dashboard`;
    }
  

  private setServiceErrorFlag(): void {
    this.serviceErrorOccurred = true;
    setTimeout(() => {
      this.serviceErrorOccurred = false;
    }, 2000);
  }

  private setBackendErrorMessage(message: any, language: string): void {
    if (language === 'en-CA') {
      this.serviceErrorDesc = message.shortMessage_EN;
    } else if (language === 'fr-CA') {
      this.serviceErrorDesc = message.shortMessage_FR;
    } else {
      this.serviceErrorDesc = message.shortMessage;
    }
  }
  submitAdminUserForm(e: Event) {
    if (!this.adminForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
      return;
    }
  //   if (this.captchaToggle) {
  //   if (this.ciamReCaptchaForm.invalid) {
  //     this.translate.get('Errors.recaptcha').subscribe((data: any) => {
  //       this.serviceErrorDesc = data;
  //       return;
  //      });
  //   }
  //  }
    this.userId = this.adminForm.get('userID').value;

  //   if (this.captchaToggle) {

  //   const userRequest = {
  //     userId : this.userId,
  //     recaptcha : this.recaptchaResponse
  //   };
  //   this.getAdminUser(userRequest);
  //  } else {
    const userRequest = {
      userId : this.userId,
      recaptcha : 'false'
    };
    this.getAdminUser(userRequest);
  // }
  }



  submitLoginForm(e: Event) {
    if(this.getUserFlag ===true){
      if (!this.loginForm.valid) {
        this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
          this.serviceErrorDesc = data;
         });
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 2000);  //2s
        return;
      }
      this.userId = this.loginForm.get('userID').value;
      this.password = this.loginForm.get('password').value;
  
      const loginRequest = {
        userId : this.userId,
        password : this.password,
        country: this.currentCountry,
        language : this.language
      };
      this.getLogin(loginRequest);
    }
    else{
      this.translate.get('Errors.IncorrectPwd').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
      return;
    }
  }

  submitPreLoginForm() {
    if(this.getUserFlag ===true){
    if (!this.loginForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
      return;
    }
    this.userId = this.loginForm.get('userID').value;
    this.password = this.loginForm.get('password').value;

    const loginRequest = {
      ciamId : this.userId,
      userId : this.userId,
      password : this.password,
      country: this.currentCountry,
      language : this.language
    };
    this.getPreLogin(loginRequest);
  } else{
    this.translate.get('Errors.IncorrectPwd').subscribe((data:any)=> {
      this.serviceErrorDesc = data;
     });
    this.serviceErrorOccurred = true;
    setTimeout(() => {
      this.serviceErrorOccurred = false;
    }, 2000);  //2s
    return;
  }
  }

  emailVerificationForLogin(e: Event){
    if (!this.loginForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
      return;
    }
    this.userId = this.loginForm.get('userID').value;
    this.password = this.loginForm.get('password').value;
  
    const loginRequest = {
      ciamId : this.userId,
      userId : this.userId,
      password : this.password,
      country: this.currentCountry,
      language : this.language,
      mfaToken: this.otp
    };
    this.getemailVerificationForLogin(loginRequest);
  }
  


  submitAdminLoginForm(e: Event) {
    if (!this.adminloginForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
      return;
    }
    this.userId = this.adminloginForm.get('userID').value;
    this.password = this.adminloginForm.get('password').value;
    const loginRequest = {
      userId : this.userId,
      password : this.password,
      country: this.currentCountry,
      language : this.language,
      recaptcha : false
    };
    this.getAdminLogin(loginRequest);
  }

//   onloadCallback() {
//     this.rendered = grecaptcha.render('capcha_element', {
//         'sitekey': this.siteKeyCaptcha,
//         'lang': this.language
//     });
// }


//   getResponceCapcha(captchaResponse: string) {
//     // this.verifyCaptcha(captchaResponse);
//     this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(captchaResponse);
//     (this._window.nativeWindow as any).scrollBy(0, 1);
//     this.recaptchaResponse = this.ciamReCaptchaForm.controls.recaptchaResponseKey.value;
// }

// recaptchaResponseExpired() {
//     this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
//     grecaptcha.reset(this.rendered);
// }
// recaptchaError() {
//     this.ciamReCaptchaForm.controls.recaptchaResponseKey.setValue(null);
//     this.translate.get('Errors.recaptcha').subscribe((data: any) => {
//       this.serviceErrorDesc = data;
//      });
// }

  changeType(input_field_password, num){
    if(input_field_password.type === 'password') {
      input_field_password.type = 'text';
    } else {
      input_field_password.type = 'password';
    }
    this.hide = !this.hide;
  }

  changeReset(){
    this.isReset = !this.isReset;
  }
  changeUser(){
    this.userExist = !this.userExist;
  }

  redirectForgot(){
     // gets password Url from property file and redirects accordingly
    this.translate.get('LoginModal.ForgotPasswordURL').subscribe((data: any) => {
      this._window.nativeWindow.location.href = this.baseUrl + data;
     });
  }

  getUser(userRequest) {
    sessionStorage.setItem('loginID', this.userId);
    this.auth.getUser(userRequest).subscribe(res => {
        if (res.userExists === true && res.passwordResetFlag === true ) { // Checks if user is reset then shows normal login page
          this.serviceErrorOccurred = false;
          this.userExist = true;
          this.isReset = true;
          this.loginForm.controls['userID'].setValue(this.userId);
          this.getUserFlag = true;
          this.submitPreLoginForm();
         } else if (res.userExists === true && res.passwordResetFlag === false) { // Checks if user is not reset then reset password flow
          this.serviceErrorOccurred = false;
          this.userExist = true;
          this.isReset = false;
          this.loginForm.controls['userID'].setValue(this.userId);
          this.getUserFlag = true;
         } else {
          if (res.statusMessage === 'FAILURE') {
            // If checks to load BE error messages based on language
            this.translate.get('Errors.IncorrectPwd').subscribe((data: any) => {
              this.serviceErrorDesc = data;
            });
            this.serviceErrorOccurred = true;
            setTimeout(() => {
              this.serviceErrorOccurred = false;
            }, 4000);  //4s
          } else {
          this.loginForm.controls['userID'].setValue(this.userId);
          this.getUserFlag = false;
          
       //  If checks to load BE error messages based on language
          if (this.language === 'en-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_EN;
          } else if (this.language === 'fr-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_FR;
          } else {
            this.serviceErrorDesc = res.status.message.shortMessage;
          }
          this.serviceErrorOccurred = true;
          setTimeout(() => {
            this.serviceErrorOccurred = false;
          }, 2000);  //2s
        }
        }
        // this.recaptchaResponseExpired(); // reset recaptcha
  });
}

getAdminUser(userRequest) {
  sessionStorage.setItem('loginID', this.userId);
  this.auth.getAdminUser(userRequest).subscribe(res => {
      if (res.userExists === true && res.passwordResetFlag === true ) { // Checks if user is reset then shows normal login page
        this.serviceErrorOccurred = false;
        this.userExist = true;
        this.getUserFlag = true;
        this.isReset = true;
        this.adminloginForm.controls['userID'].setValue(this.userId);
       } else if (res.userExists === true && res.passwordResetFlag === false) { // Checks if user is not reset then reset password flow
        this.serviceErrorOccurred = false;
        this.userExist = true;
        this.getUserFlag = true;
        this.isReset = false;
        this.adminloginForm.controls['userID'].setValue(this.userId);
       } else {
        this.getUserFlag = false;
       // If checks to load BE error messages based on language
        if (this.language === 'en-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_EN;
        } else if (this.language === 'fr-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_FR;
        } else {
          this.serviceErrorDesc = res.status.message.shortMessage;
        }
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 2000);  //2s
      }
      sessionStorage.setItem('admincheck','true');
      // this.recaptchaResponseExpired(); // reset recaptcha
});
}


    getLogin(loginRequest) {
      this.loginLoaded = false; //Spinner enabler
      this.auth.getLogin(loginRequest).subscribe(res => {
          this.loginLoaded = true;
          if (res.userValid === true && res.token !== null){
            this.serviceErrorOccurred = false;
            this.environment = (this._window.nativeWindow as any).mbfs.environment;
            this.brandId = res.brandId.toString();
            sessionStorage.setItem('auth', 'yes');
            this.auth.istoken = res.token;
            sessionStorage.setItem('customerName',res.customerName);
            sessionStorage.setItem('emailAddress',res.emailAddress);
            sessionStorage.setItem('agentview','false');
            sessionStorage.setItem("environment",this.environment);
            sessionStorage.setItem('ciamToken', this.auth.istoken);
            sessionStorage.setItem('brandId', this.brandId);
            sessionStorage.setItem('classicredirect', 'no');
            sessionStorage.setItem('forward', res.forward);
            sessionStorage.setItem('loginID', res.userId);
            sessionStorage.setItem('thirdPartyNumber', res.thirdPartyNumber);
            sessionStorage.setItem('billingNumber', res.billingNumber);
           var thirdparty = res.thirdPartyNumber;

            this.auth.isAuthenticated(); // Checks if user is authenticated
            this.openLoginModal = false;
            if (this.brandId === '2') {
              this._window.nativeWindow.location.href = this.usUrl + '/home/dashboard?thirdparty?thirdParty='+ thirdparty;
              // this.router.navigate(['home/dashboard']).then(() => {
              //   window.location.reload();
              // });
            }
            else if (loginRequest.language === 'en-CA' && this.brandId === '3') {
              this._window.nativeWindow.location.href = this.usUrl + '/ca/en/home/dashboard?thirdparty?thirdParty='+ thirdparty;
              // this.router.navigate(['ca/en/home/dashboard']).then(() => {
              //   window.location.reload();
              // });
            }
            else if (loginRequest.language === 'fr-CA'&& this.brandId === '3') {
              this._window.nativeWindow.location.href = this.usUrl + '/ca/fr/home/dashboard?thirdparty?thirdParty='+ thirdparty;
              // this.router.navigate(['ca/fr/home/dashboard']).then(() => {
              //   window.location.reload();
              // });
            }
            else if (this.brandId === '3') {
              this._window.nativeWindow.location.href = this.usUrl + '/ca/en/home/dashboard?thirdparty?thirdParty='+ thirdparty;
              // this.router.navigate(['ca/en/home/dashboard']).then(() => {
              //   window.location.reload();
              // });
            }
            else{
              this._window.nativeWindow.location.href = this.usUrl + '/home/dashboard?thirdparty='+ thirdparty;
              // this.router.navigate(['home/dashboard']).then(() => {
              //   window.location.reload();
              // });
            }
           } else if (res.userValid === false && res.token === null) {
            this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
              this.serviceErrorDesc = data;
             });
            this.serviceErrorOccurred = true;
            setTimeout(() => {
              this.serviceErrorOccurred = false;
            }, 2000);  //2s
          } else {
           // If checks to load BE error messages based on language
            if (loginRequest.language === 'en-CA') {
              this.serviceErrorDesc = res.status.message.shortMessage_EN;
            } else if (loginRequest.language === 'fr-CA') {
              this.serviceErrorDesc = res.status.message.shortMessage_FR;
            } else {
              this.serviceErrorDesc = res.status.message.shortMessage;
            }
            this.serviceErrorOccurred = true;
            setTimeout(() => {
              this.serviceErrorOccurred = false;
            }, 2000);  //2s
          }
    });
   }

   getPreLogin(loginRequest) {
    this.MFALockout = true;
    this.loginLoaded = false; //Spinner enabler
    this.auth.getPreLogin(loginRequest).subscribe(res => {
      this.loginLoaded = true; //Spinner enabler
      if (res.emailStatus === 'SUCCESS') {
      if(res.message ==="maintenance"){
        this.redirectMaintenance();
        return;
      }
      if(res.mfaStatus === 'Y'){
        this.getLogin(loginRequest);
      }
      else{
        this.email = res.email;
        this.MFACheck = true;
      }
      this.MFATimeout=false;
      setTimeout(() => {
        this.MFATimeout = true;
      }, 600000);  //10mins
    }
    else if(res.message ==="mfa count is more than 3"){
      this.translate.get('Errors.userId_locked').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
        });
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 4000);  //4s
        this.loginLoaded = true;
    }
    else {
      // If checks to load BE error messages based on language
      this.translate.get('Errors.IncorrectPwd').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
       });
       this.serviceErrorOccurred = true;
       setTimeout(() => {
         this.serviceErrorOccurred = false;
       }, 4000);  //4s
     }
  });
}

redirectMaintenance() {
  let redirect = '';
  this.translate.get('PageNotFound.MaintenanceRedirect').subscribe((data:any)=> {
    redirect= this.usUrl +  data;
   });
   window.location.href = redirect;
}

getemailVerificationForLogin(loginRequest) {
  this.MFALockout = true;
  this.loginLoaded = false; //Spinner enabler
  this.auth.emailVerificationForLogin(loginRequest).subscribe(res => {
    if(res.mfaStatus === 'Y'){
      this.login();
    }
    else if(res.message ==="mfa count is more than 3"){
      this.MFALockout = false;
      this.translate.get('Errors.userId_locked').subscribe((data:any)=> {
        this.serviceErrorDesc = data;
        });
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 4000);  //4s
        this.loginLoaded = true;
    }
    else{
    // If checks to load BE error messages based on language
    this.translate.get('Errors.userId_passwordMatch').subscribe((data:any)=> {
      this.serviceErrorDesc = data;
      });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 4000);  //4s
      this.loginLoaded = true;
    }
});
}

  getAdminLogin(loginRequest) {
    this.loginLoaded = false; //Spinner enabler
    this.auth.adminLogin(loginRequest).subscribe(res => {
        this.loginLoaded = true;
        if (res.userValid === true){
          sessionStorage.setItem("username", res.userId);
          this.auth.getAuthToken().subscribe(authRes=> {
            sessionStorage.setItem("Authorization", authRes.token);
            sessionStorage.setItem("userId", authRes.userId);
          this.serviceErrorOccurred = false;
          sessionStorage.setItem('adminauth', 'yes');
          sessionStorage.setItem('isAdmin',res.admin);
          sessionStorage.setItem('adminUserType',res.userType);
          sessionStorage.setItem('AdminName',this.userId);
          sessionStorage.setItem('emailAddress',res.emailAddress);
          this.auth.isAdminAuthenticated(); // Checks if user is authenticated
          this.openLoginModal = false;
          this._window.nativeWindow.location.href = this.usUrl + '/home/admindashboard';
        });
         } else if (res.userValid === false) {
          this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
            this.serviceErrorDesc = data;
           });
          this.serviceErrorOccurred = true;
          setTimeout(() => {
            this.serviceErrorOccurred = false;
          }, 2000);  //2s
        } else {
         // If checks to load BE error messages based on language
          if (loginRequest.language === 'en-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_EN;
          } else if (loginRequest.language === 'fr-CA') {
            this.serviceErrorDesc = res.status.message.shortMessage_FR;
          } else {
            this.serviceErrorDesc = res.status.message.shortMessage;
          }
          this.serviceErrorOccurred = true;
          setTimeout(() => {
            this.serviceErrorOccurred = false;
          }, 2000);  //2s
        }
  });
}
  togglePasswordFlag(e: Event){
    if(this.displayAdmin === true){
      this.userId = this.adminloginForm.get('userID').value;
    }
    else{
      this.userId = this.loginForm.get('userID').value;
    }
    if(this.userId){
      sessionStorage.setItem('loginID', this.userId);
      this.openLoginModal = false;
      this.userExist = false;
      this.isReset = false;
      this.serviceErrorOccurred = false;
      this.passwordResetFlag = true;
    }
    else{
      this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
        this.serviceErrorDesc = data;
       });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
      }, 2000);  //2s
    }

  }

  toggleForgotUserFlag(e: Event){
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
    this.passwordResetFlag = false;
    this.forgotUserFlag = true;

  }

  checkLogin(){
    // this.loginmodalFlag=true;
    let element:HTMLElement = document.getElementById('auto_trigger1') as HTMLElement;
    element.click();
  }

  onOtpChange(otp) {
    this.otp = otp;
  }

  setVal(val) {
    this.ngOtpInput.setValue(val);
  }

  toggleDisable(){
    if(this.ngOtpInput.otpForm){
      if(this.ngOtpInput.otpForm.disabled){
        this.ngOtpInput.otpForm.enable();
      }else{
        this.ngOtpInput.otpForm.disable();
      }
    }
  }

  onConfigChange() {
    this.showOtpComponent = false;
    this.otp = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }
}

export class HeaderExport{
}